import { Rarity } from '__generated__/globalTypes';

import {
  CollectionsFiltersState,
  StringifiedCollectionsFiltersState,
} from './types';

export const stringifyFiltersState = (
  state: CollectionsFiltersState
): StringifiedCollectionsFiltersState => {
  return {
    rarities: state.rarities?.join(',') || undefined,
    seasonStartYears: state.seasonStartYears?.join(',') || undefined,
    query: state.query || undefined,
    startedOnly: state.startedOnly ? 'true' : 'false',
    sort: state.sort,
  };
};

export const parseFiltersState = (
  stringifiedState: StringifiedCollectionsFiltersState
): CollectionsFiltersState => {
  return {
    rarities: stringifiedState.rarities
      ? (stringifiedState.rarities.split(',') as Rarity[])
      : undefined,
    seasonStartYears: stringifiedState.seasonStartYears
      ? stringifiedState.seasonStartYears.split(',').map(Number)
      : undefined,
    query: stringifiedState.query || '',
    startedOnly: stringifiedState.startedOnly === 'true',
    sort: stringifiedState.sort,
  };
};
